'use strict';
const angular = require('angular');

export class LetterAddressSelectModalComponent {
  /*@ngInject*/
  constructor() {
  }

  getAddress(address) {
    try {
      return `${address.street}, ${address.city} ${address.state}, ${address.zip}`;
    } catch (e){
      return "-";
    }
  }

  $onInit() {
    this.config = this.resolve.config;

    this.addresses = this.config.addresses.map(adr => {

      let primaryMark = adr.isPrimary ? " (Primary)" : "";

       return {
         group: adr.group,
         name: this.getAddress(adr) + " (" + adr.type + ")" + primaryMark,
         json: adr
       }
    });
  };

  ok() {
    this.close({$value: this.selectedAddress});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

}

export default angular.module('conduu.letterAddressSelectModalComponent', [])
  .component('letterAddressSelectModal', {
    template: require('./letter-address-select-modal.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: LetterAddressSelectModalComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/letter-address-select-modal/letter-address-select-modal.component.js